module.exports = __webpack_public_path__ + "static/Camping2-55248618b95b575c4d3e1711a49cbde7.jpg";